import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import ReactTooltip from "react-tooltip";
import { useIsMobile, useToasts } from "@brg/ui";
import { Tag } from "@brg/api";
import { TagsSearchModalWrapper } from "./styles.mobile";
import { modalControllerActions, useModal } from "../../../core";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions, TagsSelector } from "shared/reducers/Tags";
import { CreateLinkTo } from "shared/constants/linkTo";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { useHistory, useLocation } from "react-router-dom";
import {
  LABORATORY_PARAM,
  APPROVED_HSEDESIGN_PARAM,
} from "./selectTagsModal";
import { AppTester } from 'supporting';
import { setIsOpen } from "shared/reducers/OpenModal";
import {removeUndefined} from "../../helpers/removeUndefined";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { SelectTagsModalProps } from "./types";
import { SelectTagsModalLinkMode } from "./SelectTagsModalLinkMode";
import { SelectTagsModalTabsMode } from "./SelectTagsModalTabsMode";

const CITIES_ID = 'dc762a78dac54369b91542bcbe86bb2a';

export const SelectTagsModalMobile: FC<SelectTagsModalProps> = (props) => {
  const {
    value,
    onChange,
    max,
    ctx,
    onClose,
    maxEducationalTags,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    isCreateLocation,
    protectedTags = [],
    mode,
    requiredTags,
    isMobileMenu,
    isEdit,
    educational,
    global: globalProp,
    hasEduTags,
    viewAllTags,
    isTagEditor,
    editableTags = [],
    saveOnClick = true,
    maxTagsExceededMessageKey,
  } = props;

  const modal = useModal();
  const valueRef = useRef<Tag[]>([]);
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useIsMobile();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [showAllTagsInGroup, setShowAllTagsInGroup] = useState(false);
  const location = useLocation();
  const isProjectEdit = location.pathname.startsWith("/edit");
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isLinkMode = mode === 'link';
  const isHSEDesign = AppTester.isHSEDesign();
  const isHseSpace = AppTester.isHseSpace();
  const isAKI = AppTester.isAKI();
  const isHseSpaceSubcontext = AppTester.isHSESpaceSegmants();
  const isSuperPuper = AppTester.isSuperPuper()
  const isStartHSE = AppTester.isStartHSE();
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const isLaboratoryPage =
    window?.location.pathname.startsWith("/laboratory") ||
    Boolean(
      window.location.href
        .split("?")
        .find((l) => l === LABORATORY_PARAM.slice(1))
    );

  const {
    searchText, 
    headerTag: { current: headerTag },
    selectedTags: innerValue,
    selectedTagsIndex,
  } = useSelector(TagsSelector);

      //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
      const shouldVisibleEducationCategory = useMemo(
        () => (
          isProjectEdit && 
        ctx && (ctx?.includes('onlines_required_category') || requiredTags ||
        ctx?.includes('required_category'))), [isProjectEdit, ctx]
    )

  const shouldMoveToTop = useMemo(() => (!isProjectEdit), [isProjectEdit]);

  const optionTagsFilter = useMemo(() => {
    const shouldApplyEducationFilter = isHseSpace 
      ? (isEdit && isHseSpace)
      : !isHseSpace;
    
    return {
      isModeEditing: isEdit || false,
      ...(isHseSpace && isTagsSearchPage ? {
        isEducation: false,
        hasEduTags: false,
      } : (shouldApplyEducationFilter && (isStartHSE && isTagsSearchPage ? {
        isEducation: true,
      } : educational !== undefined ? {
        isEducation: educational,
      } : {}))),
      ...(isCreateLocation ? { 
        entityTypes: [], 
        groupIds: [CITIES_ID]
      } : ctx ? {
        entityTypes: ctx,
      } : {}),
      ...(isTagEditor && !isModer && editableTags ? {
        tagIds: editableTags || [],
      } : {}),
      ...(global ? {
        isHeaderIgnored: global,
      } : {}),
      ...(hasEduTags !== undefined && !isAKI && !(isStartHSE || isHseSpace && isTagsSearchPage) ? {
        hasEduTags: hasEduTags,
      } : {})
    };
  }, [isModer, isEdit, educational, global, ctx, hasEduTags, isTagEditor, isStartHSE, isTagsSearchPage, isHseSpace, isHseSpaceSubcontext, isAKI])

  const filter = useMemo(() => {
    if (headerTag) {
      //@ts-ignore
      const { categoryId, tagId } = headerTag;
      const groupId = categoryId || tagId;
      const result = {
        groupIds: [groupId],
        ...(headerTag.level === 2 ? {} : { contextIgnored: true }),
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(showAllTagsInGroup ? { isHeaderIgnored: true } : {}),
        ...(searchText ? {
          search: [searchText],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
        } : {}),
      };
      return result;
    }
    if (searchText) {
      return {
        search: [searchText],
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      };
    }
    return {
      lang: i18n.language,
      status: [0],
      ...optionTagsFilter
    }
  }, [hasEduTags, headerTag, searchText, i18n.language, optionTagsFilter, showAllTagsInGroup]);

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: 100,
    page: 1 
  }), [])

  const requestDisabled = viewAllTags;
  const currentLang = i18n.language || 'en';

  const tagsRequestFilter = useMemo(() => ({
    ...removeUndefined(filter),
    lang: currentLang,
  }), [filter, currentLang]);

  const [fetchedTags, loadTags] = useGetApiTags(
    tagsRequestFilter,
    currentLang,
    time,
    requestDisabled,
  );

  const [fetchedAllTags, loadAll] = useGetApiTags(
    initialAllTagsFilter,
    currentLang,
    time,
    !viewAllTags,
  );

  const load = viewAllTags ? loadAll : loadTags;

  const tags = useMemo(() => {
    if (viewAllTags) {
      //@ts-ignore
      return Array.isArray(fetchedAllTags) ? fetchedAllTags : fetchedAllTags?.data;
    }
    return fetchedTags;
  }, [viewAllTags, fetchedAllTags, fetchedTags]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const tagMap = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag) {
      return tags.reduce((result: any, tag: any) => {
        //@ts-ignore
        const innerTags = tag.additionalTags.reduce((res, innerTag) => {
          if (innerTag.level === 1) {
            return {
              ...res,
              [innerTag.tagId]: innerTag.additionalTags,
            };
          }
          return res;
        }, {});
        return {
          ...result,
          ...innerTags,
          [tag.tagId]: tag.additionalTags,
        };
      }, {});
    }
    return {};
  }, [tags, headerTag, viewAllTags]);

  useEffect(() => {
    setTime(Date.now());

  }, [filter, searchText, headerTag, showAllTagsInGroup]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const setInnerValue = (value: Tag[]) => {
    dispatch(TagsActions.setSelectedTags(value));
  };

  useEffect(() => {
    setInnerValue(value ?? []);
    dispatch(TagsActions.setOnSave((val: Tag[]) => {
      if (onChange) onChange(val);
      valueRef.current = val;
    }))
  }, []);

  const onModalClose = useCallback(([firstTag]: Tag[]): void => {
    dispatch(TagsActions.setSearchText(''))
    dispatch(TagsActions.setHeaderTag({
      current: null,
      parent: null,
    }))
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com");
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEDesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      onClose?.([firstTag]);
    }
  }, [isLaboratoryPage, isHSEDesign]);

  const checkTagsCount = useCallback(() => {
    const placesTagCount = innerValue?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    const currentTagsCount = innerValue?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', {count: maxTeamsTags}));
      setInnerValue(innerValue.slice(0, innerValue?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
        toasts.error(t('project_edit.max_project_tags_error', {count: maxProjectTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
        toasts.error(t('project_edit.max_places_tags_error', {count: maxPlacesTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }

  }, [maxProjectTags, maxPlacesTags, toasts, modal, t])

  useEffect(() => {
    if (shouldMoveToTop) {
      window.scrollTo({ top: 0 });
    }
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = '';
      if (mode === 'link') {
        onModalClose(valueRef.current);
      }
      dispatch(TagsActions.setSearchText(''))
      dispatch(TagsActions.setHeaderTag({
        current: null,
        parent: null,
      }))
      dispatch(TagsActions.setSelectedTags([]))
      dispatch(TagsActions.setOnSave(null))
    };
  }, [onClose, shouldMoveToTop, mode]);

  useEffect(() => {
    checkTagsCount();
}, [innerValue])

  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose([innerValue[0]])
      dispatch(modalControllerActions.hideModal({}));
    }
  }, [innerValue, onModalClose]);

  useEffect(() => {
    if (mainSearchRef && !isMobile) {
        mainSearchRef.current?.focus()
    }
}, [mainSearchRef, isMobile])

  const tagsScrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!tagsScrollRef.current) return;
    tagsScrollRef?.current?.scrollTo(0, 0)
  }, [headerTag, tagsScrollRef])

  const onTagSelect = (tag: Tag) => {
    const selected = selectedTagsIndex[tag.tagId];
    let v = innerValue;
    if (isTagEditor && !editableTags.includes(tag.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
      return;
    }
    if (!selected) {
      if (tag.level === 2 && isProjectEdit) {
        dispatch(TagsActions.setHeaderTag({ current: tag }));
        return;
      }
      const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);
      if (mode === 'link' || max === 1) {
        v = [tag];
      } else if (maxEducationalTags === 1 && tag?.isEducationTag && educationalTags.length >= 1) {
        v = [...innerValue.filter((t) => !t.isEducationTag), tag];
      } else if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
        toasts.error(t('project_edit.max_required_tags_error'))
      } else if (max && innerValue?.length + 1 > max) {
        toasts.error(
          maxTagsExceededMessageKey
            ? t(maxTagsExceededMessageKey)
            : t('project_edit.select_tags_max_error', { count: max }),
        );
        v = innerValue;
      } else {
        v = [...innerValue, tag];
      }
    } else if (protectedTags.includes(tag?.tagId)) {
      toasts.error("Это обязательный тег");
      return;
    } else {
      v = innerValue.filter((t) => t.tagId !== tag.tagId);
    }
    setInnerValue(v);
    
    if(tag.level === 2 && !isProjectEdit){
      dispatch(setIsOpen(true));
    }
  };

  const getGrouping = () => {
    if (viewAllTags) {
      return 1;
    }
    const isSingleTag = tags?.length === 1;
    if (headerTag || isSingleTag) {
      return searchText ? 3 : 2;
    }
    if (!headerTag && searchText) {
      return 3;
    }
    return 1;
  };

  const displayedTags = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag && !searchText) {
      return [
        {
          ...headerTag,
          additionalTags: tagMap[headerTag.tagId] || [],
        },
      ];
    }
    if (headerTag && searchText && tags.length) {
      return headerTag.level === 2 ? [tags[0]] : [tags[0]?.additionalTags?.[0]];
    }
    return tags.filter((tag: any) => !!tag?.additionalTags?.length);
  }, [tags, headerTag, viewAllTags, searchText, ungrouped, tagMap]);

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const filteredTags = (arr: any[]) => {
      return arr;
  }

  const handleMoreClick = () => {
    setShowAllTagsInGroup(true);
  };

  return (
    <TagsSearchModalWrapper isMobileMenu={isMobileMenu}>
      {isLinkMode ? (
        <SelectTagsModalLinkMode
          headerTag={headerTag}
          searchText={searchText}
          load={load}
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          isEdit={isEdit}
          onMoreClick={handleMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          t={t}
          theme={theme}
          mainSearchRef={mainSearchRef}
          tagsScrollRef={tagsScrollRef}
        />
      ) : (
        <SelectTagsModalTabsMode
          headerTag={headerTag}
          searchText={searchText}
          load={load}
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          isEdit={isEdit}
          onMoreClick={handleMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          editableTags={editableTags}
          innerValue={innerValue}
          mode={mode}
          t={t}
          theme={theme}
          mainSearchRef={mainSearchRef}
          tagsScrollRef={tagsScrollRef}
          onChange={onChange}
          saveOnClick={saveOnClick}
        />
      )}
      <ReactTooltip />
    </TagsSearchModalWrapper>
  );
};
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import ReactTooltip from "react-tooltip";
import { useIsMobile, useToasts } from "@brg/ui";
import { Tag } from "@brg/api";
import { TagsSearchModalWrapper } from "./styles.mobile";
import { modalControllerActions, useModal } from "../../../core";
import { useDispatch, useSelector } from "react-redux";
import { TagsActions, TagsSelector } from "shared/reducers/Tags";
import { CreateLinkTo } from "shared/constants/linkTo";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { useHistory, useLocation } from "react-router-dom";
import {
  LABORATORY_PARAM,
  APPROVED_HSEDESIGN_PARAM,
} from "./selectTagsModal";
import { AppTester } from 'supporting';
import { setIsOpen } from "shared/reducers/OpenModal";
import {removeUndefined} from "../../helpers/removeUndefined";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { SelectTagsModalProps } from "./types";
import { SelectTagsModalLinkMode } from "./SelectTagsModalLinkMode";
import { SelectTagsModalTabsMode } from "./SelectTagsModalTabsMode";

const CITIES_ID = 'dc762a78dac54369b91542bcbe86bb2a';

export const SelectTagsModalMobile: FC<SelectTagsModalProps> = (props) => {
  const {
    value,
    onChange,
    max,
    ctx,
    onClose,
    maxEducationalTags,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    isCreateLocation,
    protectedTags = [],
    mode,
    requiredTags,
    isMobileMenu,
    isEdit,
    educational,
    global: globalProp,
    hasEduTags,
    viewAllTags,
    isTagEditor,
    editableTags = [],
    saveOnClick = true,
    maxTagsExceededMessageKey,
  } = props;

  const modal = useModal();
  const valueRef = useRef<Tag[]>([]);
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useIsMobile();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [time, setTime] = useState(Date.now());
  const [showAllTagsInGroup, setShowAllTagsInGroup] = useState(false);
  const location = useLocation();
  const isProjectEdit = location.pathname.startsWith("/edit");
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isLinkMode = mode === 'link';
  const isHSEDesign = AppTester.isHSEDesign();
  const isHseSpace = AppTester.isHseSpace();
  const isAKI = AppTester.isAKI();
  const isHseSpaceSubcontext = AppTester.isHSESpaceSegmants();
  const isSuperPuper = AppTester.isSuperPuper()
  const isStartHSE = AppTester.isStartHSE();
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const isLaboratoryPage =
    window?.location.pathname.startsWith("/laboratory") ||
    Boolean(
      window.location.href
        .split("?")
        .find((l) => l === LABORATORY_PARAM.slice(1))
    );

  const {
    searchText, 
    headerTag: { current: headerTag },
    selectedTags: innerValue,
    selectedTagsIndex,
  } = useSelector(TagsSelector);

      //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
      const shouldVisibleEducationCategory = useMemo(
        () => (
          isProjectEdit && 
        ctx && (ctx?.includes('onlines_required_category') || requiredTags ||
        ctx?.includes('required_category'))), [isProjectEdit, ctx]
    )

  const shouldMoveToTop = useMemo(() => (!isProjectEdit), [isProjectEdit]);

  const optionTagsFilter = useMemo(() => {
    const shouldApplyEducationFilter = isHseSpace 
      ? (isEdit && isHseSpace)
      : !isHseSpace;
    
    return {
      isModeEditing: isEdit || false,
      ...(isHseSpace && isTagsSearchPage ? {
        isEducation: false,
        hasEduTags: false,
      } : (shouldApplyEducationFilter && (isStartHSE && isTagsSearchPage ? {
        isEducation: true,
      } : educational !== undefined ? {
        isEducation: educational,
      } : {}))),
      ...(isCreateLocation ? { 
        entityTypes: [], 
        groupIds: [CITIES_ID]
      } : ctx ? {
        entityTypes: ctx,
      } : {}),
      ...(isTagEditor && !isModer && editableTags ? {
        tagIds: editableTags || [],
      } : {}),
      ...(global ? {
        isHeaderIgnored: global,
      } : {}),
      ...(hasEduTags !== undefined && !isAKI && !(isStartHSE || isHseSpace && isTagsSearchPage) ? {
        hasEduTags: hasEduTags,
      } : {})
    };
  }, [isModer, isEdit, educational, global, ctx, hasEduTags, isTagEditor, isStartHSE, isTagsSearchPage, isHseSpace, isHseSpaceSubcontext, isAKI])

  const filter = useMemo(() => {
    if (headerTag) {
      //@ts-ignore
      const { categoryId, tagId } = headerTag;
      const groupId = categoryId || tagId;
      const result = {
        groupIds: [groupId],
        ...(headerTag.level === 2 ? {} : { contextIgnored: true }),
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(showAllTagsInGroup ? { isHeaderIgnored: true } : {}),
        ...(searchText ? {
          search: [searchText],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
        } : {}),
      };
      return result;
    }
    if (searchText) {
      return {
        search: [searchText],
        status: [0],
        lang: i18n.language,
        ...optionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      };
    }
    return {
      lang: i18n.language,
      status: [0],
      ...optionTagsFilter
    }
  }, [hasEduTags, headerTag, searchText, i18n.language, optionTagsFilter, showAllTagsInGroup]);

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: 100,
    page: 1 
  }), [])

  const requestDisabled = viewAllTags;
  const currentLang = i18n.language || 'en';

  const tagsRequestFilter = useMemo(() => ({
    ...removeUndefined(filter),
    lang: currentLang,
  }), [filter, currentLang]);

  const [fetchedTags, loadTags] = useGetApiTags(
    tagsRequestFilter,
    currentLang,
    time,
    requestDisabled,
  );

  const [fetchedAllTags, loadAll] = useGetApiTags(
    initialAllTagsFilter,
    currentLang,
    time,
    !viewAllTags,
  );

  const load = viewAllTags ? loadAll : loadTags;

  const tags = useMemo(() => {
    if (viewAllTags) {
      //@ts-ignore
      return Array.isArray(fetchedAllTags) ? fetchedAllTags : fetchedAllTags?.data;
    }
    return fetchedTags;
  }, [viewAllTags, fetchedAllTags, fetchedTags]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const tagMap = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag) {
      return tags.reduce((result: any, tag: any) => {
        //@ts-ignore
        const innerTags = tag.additionalTags.reduce((res, innerTag) => {
          if (innerTag.level === 1) {
            return {
              ...res,
              [innerTag.tagId]: innerTag.additionalTags,
            };
          }
          return res;
        }, {});
        return {
          ...result,
          ...innerTags,
          [tag.tagId]: tag.additionalTags,
        };
      }, {});
    }
    return {};
  }, [tags, headerTag, viewAllTags]);

  useEffect(() => {
    setTime(Date.now());

  }, [filter, searchText, headerTag, showAllTagsInGroup]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const setInnerValue = (value: Tag[]) => {
    dispatch(TagsActions.setSelectedTags(value));
  };

  useEffect(() => {
    setInnerValue(value ?? []);
    dispatch(TagsActions.setOnSave((val: Tag[]) => {
      if (onChange) onChange(val);
      valueRef.current = val;
    }))
  }, []);

  const onModalClose = useCallback(([firstTag]: Tag[]): void => {
    dispatch(TagsActions.setSearchText(''))
    dispatch(TagsActions.setHeaderTag({
      current: null,
      parent: null,
    }))
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com");
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEDesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      onClose?.([firstTag]);
    }
  }, [isLaboratoryPage, isHSEDesign]);

  const checkTagsCount = useCallback(() => {
    const placesTagCount = innerValue?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    const currentTagsCount = innerValue?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', {count: maxTeamsTags}));
      setInnerValue(innerValue.slice(0, innerValue?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
        toasts.error(t('project_edit.max_project_tags_error', {count: maxProjectTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
        toasts.error(t('project_edit.max_places_tags_error', {count: maxPlacesTags}));
        setInnerValue(innerValue.slice(0, innerValue?.length - 1))
        return;
    }

  }, [maxProjectTags, maxPlacesTags, toasts, modal, t])

  useEffect(() => {
    if (shouldMoveToTop) {
      window.scrollTo({ top: 0 });
    }
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = '';
      if (mode === 'link') {
        onModalClose(valueRef.current);
      }
      dispatch(TagsActions.setSearchText(''))
      dispatch(TagsActions.setHeaderTag({
        current: null,
        parent: null,
      }))
      dispatch(TagsActions.setSelectedTags([]))
      dispatch(TagsActions.setOnSave(null))
    };
  }, [onClose, shouldMoveToTop, mode]);

  useEffect(() => {
    checkTagsCount();
}, [innerValue])

  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose([innerValue[0]])
      dispatch(modalControllerActions.hideModal({}));
    }
  }, [innerValue, onModalClose]);

  useEffect(() => {
    if (mainSearchRef && !isMobile) {
        mainSearchRef.current?.focus()
    }
}, [mainSearchRef, isMobile])

  const tagsScrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!tagsScrollRef.current) return;
    tagsScrollRef?.current?.scrollTo(0, 0)
  }, [headerTag, tagsScrollRef])

  const onTagSelect = (tag: Tag) => {
    const selected = selectedTagsIndex[tag.tagId];
    let v = innerValue;
    if (isTagEditor && !editableTags.includes(tag.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
      return;
    }
    if (!selected) {
      if (tag.level === 2 && isProjectEdit) {
        dispatch(TagsActions.setHeaderTag({ current: tag }));
        return;
      }
      const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);
      if (mode === 'link' || max === 1) {
        v = [tag];
      } else if (maxEducationalTags === 1 && tag?.isEducationTag && educationalTags.length >= 1) {
        v = [...innerValue.filter((t) => !t.isEducationTag), tag];
      } else if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
        toasts.error(t('project_edit.max_required_tags_error'))
      } else if (max && innerValue?.length + 1 > max) {
        toasts.error(
          maxTagsExceededMessageKey
            ? t(maxTagsExceededMessageKey)
            : t('project_edit.select_tags_max_error', { count: max }),
        );
        v = innerValue;
      } else {
        v = [...innerValue, tag];
      }
    } else if (protectedTags.includes(tag?.tagId)) {
      toasts.error("Это обязательный тег");
      return;
    } else {
      v = innerValue.filter((t) => t.tagId !== tag.tagId);
    }
    setInnerValue(v);
    
    if(tag.level === 2 && !isProjectEdit){
      dispatch(setIsOpen(true));
    }
  };

  const getGrouping = () => {
    if (viewAllTags) {
      return 1;
    }
    const isSingleTag = tags?.length === 1;
    if (headerTag || isSingleTag) {
      return searchText ? 3 : 2;
    }
    if (!headerTag && searchText) {
      return 3;
    }
    return 1;
  };

  const displayedTags = useMemo(() => {
    if (viewAllTags) {
      return tags;
    }
    if (headerTag && !searchText) {
      return [
        {
          ...headerTag,
          additionalTags: tagMap[headerTag.tagId] || [],
        },
      ];
    }
    if (headerTag && searchText && tags.length) {
      return headerTag.level === 2 ? [tags[0]] : [tags[0]?.additionalTags?.[0]];
    }
    return tags.filter((tag: any) => !!tag?.additionalTags?.length);
  }, [tags, headerTag, viewAllTags, searchText, ungrouped, tagMap]);

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const filteredTags = (arr: any[]) => {
      return arr;
  }

  const handleMoreClick = () => {
    setShowAllTagsInGroup(true);
  };

  return (
    <TagsSearchModalWrapper isMobileMenu={isMobileMenu}>
      {isLinkMode ? (
        <SelectTagsModalLinkMode
          headerTag={headerTag}
          searchText={searchText}
          load={load}
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          isEdit={isEdit}
          onMoreClick={handleMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          t={t}
          theme={theme}
          mainSearchRef={mainSearchRef}
          tagsScrollRef={tagsScrollRef}
        />
      ) : (
        <SelectTagsModalTabsMode
          headerTag={headerTag}
          searchText={searchText}
          load={load}
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          isEdit={isEdit}
          onMoreClick={handleMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          editableTags={editableTags}
          innerValue={innerValue}
          mode={mode}
          t={t}
          theme={theme}
          mainSearchRef={mainSearchRef}
          tagsScrollRef={tagsScrollRef}
          onChange={onChange}
          saveOnClick={saveOnClick}
        />
      )}
      <ReactTooltip />
    </TagsSearchModalWrapper>
  );
};
